export default "__VITE_ASSET__CbfO4ApJ__"